import React, { Component } from 'react';
import { Modal, Input, Form } from 'antd';
import UploadFile from '@comm/upload/UploadFile';

class ModalFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        params.name = values.name;
        params.files = values.files;
        this.props.onOk(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="新增文件"
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.onCancel}
      >
        <Form>
          <Form.Item label="文件名称" {...ItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请填写文件名称' }],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="附件上传" {...ItemLayout}>
            {getFieldDecorator('files', {
              rules: [{ required: true, message: '请上传附件' }],
            })(<UploadFile type="ghost" isPreview />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalFiles);



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetail/ModalFileAdd.js